(function () {
  function getCookie(name) {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
      var pair = cookies[i].split('=');
      if (pair[0] === name) return decodeURIComponent(pair[1]);
    }
    return null;
  }

  function detectAspiration(cookieVal) {
    if (!cookieVal) return 'default';
    var v = cookieVal.toLowerCase();
    if (v.indexOf('grandkid') !== -1) return 'grandkids';
    if (v.indexOf('travel') !== -1) return 'travel';
    if (v.indexOf('off medication') !== -1 || v.indexOf('get off') !== -1) return 'off_meds';
    if (v.indexOf('dreading') !== -1) return 'stop_dreading';
    if (v.indexOf('all of') !== -1) return 'all';
    return 'all';
  }

  var aspirationLines = {
    grandkids:     'So you can be there for your grandkids \u2014 for every milestone.',
    travel:        'So you can travel and stay active \u2014 without health anxiety holding you back.',
    off_meds:      'So you can finally get off medication \u2014 or avoid ever starting.',
    stop_dreading: 'So you can stop dreading every doctor\u2019s visit \u2014 and just live.',
    all:           'So you can be there for your family, stay active, and live without fear.',
    default:       'So you can take control of your arterial health \u2014 starting today.'
  };

  function injectContent() {
    var aspirationKey = detectAspiration(getCookie('aspiration'));
    var echoEl = document.querySelector('.nato-aspiration-echo');
    if (!echoEl) return;
    echoEl.textContent = aspirationLines[aspirationKey] || aspirationLines.default;
    echoEl.style.display = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectContent);
  } else {
    injectContent();
  }
})();
